/**
 * Decodes a JWT's payload segment as UTF-8 JSON.
 *
 * `atob` yields a Latin-1 "binary string", so a non-ASCII claim came out as mojibake
 * ("SÃ£o Paulo") the moment feature 040 put a município in the token — every claim before it was
 * ASCII, which is why the shortcut survived. Bytes first, then text (Constitution XII: parsing
 * only; nothing here persists the token).
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const segment = token.split('.')[1];
  if (!segment) return null;
  try {
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as Record<string, unknown>;
  } catch {
    return null;
  }
}
